export const menAccessories = [
    {   
        id: 0,
        name: 'Army cap',
        price: 4.99,
        image: './asset/men-accessories.png'
    },   
    {
        id: 1,
        name: 'Round cap',
        price: 4.99,
        image: './asset/men-accessories1.png'
    },
    {
        id: 2,
        name: 'Cap white',
        price: 4.99,
        image: './asset/men-accessories2.png'
    },
    {
        id: 3,
        name: 'Cap black',
        price: 4.99,
        image: './asset/men-accessories3.png'
    },
    {
        id: 4,
        name: 'Cap red',
        price: 4.99,
        image: './asset/men-accessories4.png'
    },
    {
        id: 5,
        name: 'Sling bag black',
        price: 6.99,
        image: './asset/men-accessories5.png'
    },
    {
        id: 6,
        name: 'Backpack red',
        price: 9.99,
        image: './asset/men-accessories6.png'
    },
    {
        id: 7,
        name: 'Backpack black',
        price: 9.99,
        image: './asset/men-accessories7.png'
    },
    {
        id: 8,
        name: 'Sling black',
        price: 9.99,
        image: './asset/men-accessories8.png'
    },
    {
        id: 9,
        name: 'Office backpack',
        price: 6.99,
        image: './asset/men-accessories9.png'
    },
    {
        id: 10,
        name: 'Sling brown',
        price: 9.99,
        image: './asset/men-accessories10.png'
    },
    {
        id: 11,
        name: 'Wallet bag',
        price: 4.99,
        image: './asset/men-accessories11.png'
    },
    {
        id: 12,
        name: 'Leather red',
        price: 6.99,
        image: './asset/men-accessories12.png'
    },
    {
        id: 13,
        name: 'Leather brown',
        price: 6.99,
        image: './asset/men-accessories13.png'
    },
    {
        id: 14,
        name: 'Wallet design',
        price: 6.99,
        image: './asset/men-accessories14.png'
    },
    {
        id: 15,
        name: 'Rounded shades',
        price: 4.99,
        image: './asset/men-accessories15.png'
    },
    {
        id: 16,
        name: 'Rect shades',
        price: 4.99,
        image: './asset/men-accessories16.png'
    },
    {
        id: 17,
        name: 'Round shades',
        price: 4.99,
        image: './asset/men-accessories17.png'
    },
    {
        id: 18,
        name: 'Eagle rainbow',
        price: 4.99,
        image: './asset/men-accessories18.png'
    },
    {
        id: 19,
        name: 'Eagle eye yellow',
        price: 4.99,
        image: './asset/men-accessories19.png'
    },
    {
        id: 20,
        name: 'Cool perfume',
        price: 4.99,
        image: './asset/men-accessories21.png'
    },
    {
        id: 21,
        name: '1M perfume',
        price: 4.99,
        image: './asset/men-accessories22.png'
    },

    ]